import React from 'react';
import './Order.css';

const Order = () => {
    return (
        <div>
            <h1>Order Page</h1>
        </div>
    );
};

export default Order;